import React from "react";
import { useInput, FieldProps } from "react-admin";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

type Choice = { id: string | number; name: string };

interface Props extends Partial<FieldProps> {
  source: string;
  label?: string;
  choices: Choice[];
  fullWidth?: boolean;
  defaultValue?: any;
}

const CustomSelectInput: React.FC<Props> = ({
  source,
  label,
  choices,
  fullWidth = true,
  defaultValue,
}) => {
  const { field, fieldState, formState } = useInput({ source, defaultValue });

  const value = field.value ?? "";

  return (
    <FormControl fullWidth={fullWidth} error={!!fieldState.error}>
      <InputLabel id={`${source}-label`}>{label}</InputLabel>
      <Select
        labelId={`${source}-label`}
        value={value}
        label={label}
        onChange={(e) => field.onChange(e.target.value)}
        onBlur={field.onBlur}
      >
        {choices.map((c) => (
          <MenuItem key={String(c.id)} value={c.id}>
            {c.name}
          </MenuItem>
        ))}
      </Select>
      {fieldState.error ? (
        <FormHelperText>{fieldState.error.message}</FormHelperText>
      ) : formState.submitCount > 0 ? null : null}
    </FormControl>
  );
};

export default CustomSelectInput;
